import { render } from "./developing.vue?vue&type=template&id=425eae51&scoped=true"
import script from "./developing.vue?vue&type=script&lang=js"
export * from "./developing.vue?vue&type=script&lang=js"

import "./developing.vue?vue&type=style&index=0&id=425eae51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425eae51"]])

export default __exports__